import React, { useCallback, useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	onChange: (value: string) => void;
	setId: string;
}

export const CardContractNumber: React.FC<IProps> = React.memo(({ onChange, setId }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterCardContractNumber') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const valueWithoutLeadingSpaces = e.target.value.trimStart();
			onChange(valueWithoutLeadingSpaces);
			return valueWithoutLeadingSpaces;
		},
		[onChange],
	);

	const handleBlur = useCallback(
		(e: React.FocusEvent<HTMLInputElement>) => {
			const trimmedValue = e.target.value.trim();
			if (trimmedValue !== e.target.value) {
				onChange(trimmedValue);
			}
		},
		[onChange],
	);

	return (
		<FormInput
			testId="CardContractNumber"
			name={`cardContractNumber-${setId}`}
			label="cardContractNumberLabel"
			getValueFromEvent={handleChange}
			onBlur={handleBlur}
			validationRules={validationRules}
		/>
	);
});
